import { startOfDay } from "date-fns";

/**
 * A copied billing rule or rating table starts today and has a blank end date.
 */
export const defaultCopyEffectiveDates = () => ({
  effectiveStartDate: startOfDay(new Date()),
  effectiveEndDate: null as Date | null,
});
